<template>
	<div>
		<header class="flex-apart">
			<div>
				<h1 class="alpha heavy">Health Monitor</h1>
			</div>
		</header>
		<div>
			<loader v-if="!healthData"/>
			<template v-else>
				<dl class="sections">
					<component
						:is="check.name"
						v-for="(check, checkIndex) in healthData.checkResults"
						:key="checkIndex"
						:check="check"/>
				</dl>
			</template>
		</div>
	</div>
</template>
<script>
import AppMemory from "./healthMonitor/checks/AppMemory.vue";
import CpuLoad from "./healthMonitor/checks/CpuLoad";
import Database from "./healthMonitor/checks/Database";
import DatabaseConnections from "./healthMonitor/checks/DatabaseConnections";
import DatabaseTableSize from "./healthMonitor/checks/DatabaseTableSize";
import DebugMode from "./healthMonitor/checks/DebugMode";
import Disk from "./healthMonitor/checks/Disk";
import Environment from "./healthMonitor/checks/Environment";
import Memory from "./healthMonitor/checks/Memory";
import Optimization from "./healthMonitor/checks/Optimization";
import QueuePerformance from "./healthMonitor/checks/QueuePerformance";
import QueueSize from "./healthMonitor/checks/QueueSize";
import Schedule from "./healthMonitor/checks/Schedule";
import SecurityAdvisories from "./healthMonitor/checks/SecurityAdvisories";
import MailCatcher from "./healthMonitor/checks/MailCatcher.vue";

export default {
	components: {
		AppMemory,
		CpuLoad,
		Database,
		DatabaseConnections,
		DatabaseTableSize,
		DebugMode,
		Disk,
		Environment,
		MailCatcher,
		Memory,
		Optimization,
		QueuePerformance,
		QueueSize,
		Schedule,
		SecurityAdvisories,
	},
	data() {
		return {
			healthData: null,
		};
	},

	created() {
		http().get("tools/health").then(response => {
			this.healthData = response.data;
		});
	},
};
</script>
